<app-base-modal
  [title]="'Просмотр файлов'"
  [isNeedFullScreenBtn]="true"
>
  <div class="container">
    @switch (previewFileDialogData.type.at(0)) {
      @case ('image') {
        <img
          class="content"
          [src]="fileUrl"
          [class]="{
            'fullscreen': fullScreenStateService.fullScreenState(),
            'with-comment': isNeedCommentField,
            'without-comment': !isNeedCommentField
          }"
          width="1160"
          height="650"
          alt=""
        />
      }
      @case ('video') {
        <video
          controls
          class="content without-comment"
          [class.fullscreen]="fullScreenStateService.fullScreenState()"
        >
          <source
            [src]="previewFileDialogData.url"
            [type]="previewFileDialogData.type.join('/')"
          >
        </video>
      }
      @case ('application') {
        <iframe
          frameborder="0"
          class="content"
          [class.fullscreen]="fullScreenStateService.fullScreenState()"
          [src]="getSafeUrl(previewFileDialogData.url)"
        ></iframe>
      }
    }
    @if (isNeedCommentField) {
      <div class="comment">
        <mat-form-field
          appearance="outline"
          class="comment-form-field"
        >
          <mat-label>Комментарий</mat-label>
          <textarea
            matInput
            cdkTextareaAutosize
            cdkAutosizeMinRows="2"
            cdkAutosizeMaxRows="4"
            type="text"
            [(ngModel)]="comment"
            (blur)="handleCommentChange()"
          ></textarea>

        </mat-form-field>
        <button
          mat-mini-fab
          class="fullscreen-text"
          (click)="handleOpenFullscreenText()"
        >
          <mat-icon class="fullscreen-text-icon">fullscreen</mat-icon>
        </button>
      </div>
    }
  </div>
  <div class="buttons-container">
    @if (previewFileDialogData.isNeedArrow) {
      <div class="arrow-btns">
        <button
          mat-icon-button
          color="primary"
          (click)="navigateFile(-1)"
        >
          <mat-icon>arrow_back</mat-icon>
        </button>
        <button
          mat-icon-button
          color="primary"
          (click)="navigateFile(1)"
        >
          <mat-icon>arrow_forward</mat-icon>
        </button>
      </div>
    }
    <button
      mat-button
      color="primary"
      (click)="closeDialog('cancel')"
    >
      Закрыть
    </button>
  </div>
</app-base-modal>
